import React, { useState, useEffect } from 'react';
import { certificateAPI, letterAPI } from '../api/documents';
import '../styles/ManageDocuments.css';

function ManageDocuments() {
  const [activeTab, setActiveTab] = useState('certificates');
  const [certificates, setCertificates] = useState([]);
  const [letters, setLetters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAllDocuments();
  }, []);

  const loadAllDocuments = async () => {
    setLoading(true);
    try {
      const [certsData, lettersData] = await Promise.all([
        certificateAPI.getAll(),
        letterAPI.getAll(),
      ]);
      setCertificates(certsData);
      setLetters(lettersData);
    } catch (error) {
      console.error('Failed to load documents:', error);
    } finally {
      setLoading(false);
    }
  };

  const downloadCertificatePDF = (certId) => {
    certificateAPI.downloadPDF(certId);
  };

  const downloadLetterPDF = (id) => {
    letterAPI.downloadPDF(id);
  };



  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const handleDeleteCertificate = async (id, name) => {
    if (window.confirm(`Are you sure you want to delete the certificate for ${name}?`)) {
      try {
        await certificateAPI.delete(id);
        setCertificates(certificates.filter(cert => cert.id !== id));
        alert('Certificate deleted successfully');
      } catch (error) {
        console.error('Failed to delete certificate:', error);
        alert('Failed to delete certificate');
      }
    }
  };

  const handleDeleteLetter = async (id, subject) => {
    if (window.confirm(`Are you sure you want to delete the letter "${subject}"?`)) {
      try {
        await letterAPI.delete(id);
        setLetters(letters.filter(letter => letter.id !== id));
        alert('Letter deleted successfully');
      } catch (error) {
        console.error('Failed to delete letter:', error);
        alert('Failed to delete letter');
      }
    }
  };



  return (
    <div className="manage-documents-page">
      <div className="manage-container">
        <h1 className="page-title">Manage Documents</h1>

        <div className="tabs">
          <button
            className={`tab ${activeTab === 'certificates' ? 'active' : ''}`}
            onClick={() => setActiveTab('certificates')}
          >
            📜 Certificates ({certificates.length})
          </button>
          <button
            className={`tab ${activeTab === 'letters' ? 'active' : ''}`}
            onClick={() => setActiveTab('letters')}
          >
            ✉️ Letters ({letters.length})
          </button>

        </div>

        {loading ? (
          <div className="loading">Loading documents...</div>
        ) : (
          <div className="documents-content">
            {activeTab === 'certificates' && (
              <div className="documents-list">
                {certificates.length === 0 ? (
                  <p className="empty-state">No certificates found</p>
                ) : (
                  certificates.map((cert) => (
                    <div key={cert.id} className="document-card">
                      <div className="doc-header">
                        <h3>{cert.name}</h3>
                        <span className="status-badge valid">
                          Verified
                        </span>
                      </div>
                      <div className="doc-details">
                        <p><strong>Certificate ID:</strong> {cert.cert_id}</p>
                        <p><strong>College:</strong> {cert.college}</p>
                        <p><strong>Domain:</strong> {cert.domain}</p>
                        <p><strong>Duration:</strong> {formatDate(cert.start_date)} - {formatDate(cert.end_date)} ({cert.days} days)</p>
                        <p><strong>Created:</strong> {formatDate(cert.created)}</p>
                      </div>
                      <div className="doc-actions">
                        <button onClick={() => downloadCertificatePDF(cert.id)} className="btn-download">
                          📥 Download PDF
                        </button>
                        <button
                          onClick={() => handleDeleteCertificate(cert.id, cert.name)}
                          className={`btn-delete`}
                        >
                          🗑️ Delete
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}

            {activeTab === 'letters' && (
              <div className="documents-list">
                {letters.length === 0 ? (
                  <p className="empty-state">No letters found</p>
                ) : (
                  letters.map((letter) => (
                    <div key={letter.id} className="document-card">
                      <div className="doc-header">
                        <h3>{letter.subject}</h3>
                      </div>
                      <div className="doc-details">
                        <p><strong>Reference No:</strong> {letter.ref_no}</p>
                        <p><strong>To:</strong> {letter.to_name}</p>
                        <p><strong>Created:</strong> {formatDate(letter.created_at)}</p>
                        <p className="letter-preview">{letter.body?.substring(0, 150)}...</p>
                      </div>
                      <div className="doc-actions">
                        <button onClick={() => downloadLetterPDF(letter.id)} className="btn-download">
                          📥 Download PDF
                        </button>
                        <button
                          onClick={() => handleDeleteLetter(letter.id, letter.subject)}
                          className="btn-delete"
                        >
                          🗑️ Delete
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}


          </div>
        )}
      </div>
    </div>
  );
}

export default ManageDocuments;
